import type { FormattedCountry } from '@velasca/utils/format-countries'
import { getStoreUrlByCountry } from '@velasca/utils/get-store-url-by-country'
import { CountryFlag, CountryWrap } from './CountryElement.styles'

const domainsRegistry = {
  row_domain: window.row_domain,
  eu_domain: window.eu_domain,
  it_domain: window.it_domain,
  fr_domain: window.fr_domain,
  uk_domain: window.uk_domain,
  dk_domain: window.dk_domain,
  us_domain: window.us_domain,
  de_domain: window.de_domain,
  eu_isocode: window.eu_isocode,
  it_isocode: window.it_isocode,
  fr_isocode: window.fr_isocode,
  uk_isocode: window.uk_isocode,
  dk_isocode: window.dk_isocode,
  us_isocode: window.us_isocode,
  de_isocode: window.de_isocode,
}

interface CountryElementProps {
  country: FormattedCountry
}

export const CountryElement = ({
  country,
}: CountryElementProps): JSX.Element => {
  return (
    <CountryWrap>
      <CountryFlag
        className={
          country.code === 'AN'
            ? 'flag-icon-nl'
            : `flag-icon-${country.code.toLowerCase()}`
        }
      />
      <a
        href={getStoreUrlByCountry(country.code, domainsRegistry)}
        // TODO: due to the EEA, aria labels and alt has been added in en only. Define how to handle this in the future for a EEA assessment and complete implementation
        aria-label={`Switch to ${country.label}`}
      >
        {country.label}
      </a>
    </CountryWrap>
  )
}
